module.exports = __webpack_public_path__ + "static/img/partner_VII.7d4076e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_VII.png
// module id = Cp0H
// module chunks = 9